export class ScriptLoader {
  src: string;
  global: string;
  isLoaded: boolean;

  constructor(options: { src: string; global: string }) {
    const { src, global } = options;
    this.src = src;
    this.global = global;
    this.isLoaded = false;
  }

  loadScript(): Promise<HTMLScriptElement> {
    return new Promise((resolve, reject) => {
      // Создаем скрипт и добавляем атрибуты
      const script = document.createElement('script');
      script.type = 'text/javascript';
      script.async = true;
      script.src = this.src;

      // Добавляем в DOM
      const el = document.getElementsByTagName('script')[0];
      if (!el.parentNode) {
        return;
      }
      el.parentNode.insertBefore(script, el);

      // Ставим флаг, когда завершилась загрузка js
      script.addEventListener('load', () => {
        this.isLoaded = true;
        resolve(script);
      });

      script.addEventListener('error', () => {
        reject(new Error(`${this.src} failed to load.`));
      });
    });
  }

  load(): Promise<any> {
    // eslint-disable-next-line no-async-promise-executor
    return new Promise(async (resolve, reject) => {
      // если есть флаг, берем из window и не грузим повторно
      if (!this.isLoaded) {
        try {
          await this.loadScript();
          resolve(window[this.global]);
        } catch (e) {
          reject(e);
        }
      } else {
        resolve(window[this.global]);
      }
    });
  }
}
